import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomangaoncab() {



  const cardData = {
"keyword": "Pune to Mangaon Cab",

"headingDescription":
  "Shivai Travels offers reliable and comfortable Pune to Mangaon Cab for travelers seeking safe, affordable, and convenient transportation towards the Konkan region of Maharashtra. Whether you are planning a family trip, business visit, weekend getaway, pilgrimage, or coastal exploration, our taxi service ensures a smooth and stress-free journey. With experienced drivers who are well-versed with ghat roads and Konkan highway routes, clean air-conditioned vehicles maintained for long-distance comfort, and transparent pricing with no hidden charges, we provide a dependable travel experience from Pune to Mangaon. Our fleet includes sedans, SUVs, Innova cars, and premium vehicles suitable for solo travelers, families, and groups. With flexible one-way and round-trip options, doorstep pickup from Pune, easy cab booking, and 24/7 customer support, Shivai Travels ensures a comfortable and well-planned journey to Mangaon and nearby Konkan destinations.",

"topPlaces": [
  {
    "title": "Kumbhe Waterfall",
    "description":
      "Kumbhe Waterfall near Mangaon is a hidden natural gem in the Konkan region known for its multi-tiered cascade, lush green surroundings, and peaceful trekking trails, especially beautiful during monsoon season."
  },
  {
    "title": "Tamhini Ghat",
    "description":
      "Tamhini Ghat is a scenic mountain pass on the route between Pune and Mangaon, famous for dense forests, misty valleys, waterfalls, and breathtaking views of the Western Ghats."
  },
  {
    "title": "Ghosale Caves",
    "description":
      "Ghosale Caves near Mangaon are ancient rock-cut Buddhist caves known for their historical importance, simple carvings, and quiet natural surroundings ideal for exploration."
  },
  {
    "title": "Kundalika River Region",
    "description":
      "The Kundalika River region near Mangaon is known for its natural beauty and adventure activities in nearby areas, offering scenic landscapes and a refreshing rural environment."
  },
  {
    "title": "Kolad (Nearby Adventure Hub)",
    "description":
      "Kolad is close to Mangaon and is famous for river rafting on the Kundalika River, attracting adventure lovers from Pune for weekend trips and outdoor activities."
  },
  {
    "title": "Mangaon Town Center",
    "description":
      "Mangaon is an important town in Raigad district known for its connectivity to Konkan villages, local markets, and its role as a transit point towards coastal Maharashtra."
  },
  {
    "title": "Indapur–Mangaon Highway Route",
    "description":
      "The Pune to Mangaon route passes through smooth highways and rural Maharashtra landscapes, offering a comfortable drive through greenery, ghats, and small villages."
  },
  {
    "title": "Sahyadri Forest Belt",
    "description":
      "The Sahyadri forest belt around Mangaon is rich in biodiversity, scenic greenery, and seasonal waterfalls, making the journey from Pune visually refreshing and peaceful."
  },
  {
    "title": "Konkan Gateway Region",
    "description":
      "Mangaon serves as a gateway to the Konkan region, connecting travelers from Pune to coastal districts with beaches, forts, and natural attractions."
  },
  {
    "title": "Raigad Coastal Extension Route",
    "description":
      "The Pune to Mangaon cab route is part of the broader Raigad coastal corridor, offering access to forts, rivers, forests, and scenic Konkan landscapes."
  }
],



services: [
  {
    name: "Pune to Mangaon Cab",
    description: "Pune to Mangaon cab service provides reliable transportation for passengers traveling between Pune and Mangaon with comfortable vehicles and experienced drivers. Vehicles are suitable for long-distance Konkan highway travel ensuring smooth and timely journeys for families, tourists, corporate travelers, and local passengers. Pickup services are available from homes, hotels, railway stations, offices, and airport terminals across Pune. Vehicles include sedans, SUVs, Innova Crysta, and premium taxis suitable for different travel requirements. Flexible booking options allow convenient Pune to Mangaon cab reservations."
  },
  {
    name: "Pune to Mangaon Taxi",
    description: "Pune to Mangaon taxi service offers dependable transportation for Konkan outstation travel with professional chauffeurs and comfortable vehicles. Vehicles provide spacious seating and smooth highway travel suitable for business trips, family travel, tourism, and intercity journeys. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient Pune to Mangaon taxi reservations."
  },
  {
    name: "Cab from Pune to Mangaon",
    description: "Cab from Pune to Mangaon service provides comfortable transportation for passengers traveling from Pune to Mangaon and nearby Konkan destinations. Vehicles ensure reliable highway travel with experienced chauffeurs offering safe and smooth travel journeys. Pickup services are available from residential areas, offices, hotels, railway stations, and nearby locations across Pune. Ideal for business travelers, tourists, and family travel requirements. Flexible booking options allow convenient cab reservations."
  },
  {
    name: "Taxi from Pune to Mangaon",
    description: "Taxi from Pune to Mangaon service offers reliable transportation with comfortable vehicles and professional drivers for passengers requiring direct travel between Pune and Mangaon. Vehicles provide smooth city and highway travel suitable for tourism, business visits, Konkan holidays, and family travel. Professional drivers ensure safe driving and timely pickup services throughout the journey. Pickup services are available directly from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow easy taxi reservations."
  },
  {
    name: "Pune to Mangaon Cab Service",
    description: "Pune to Mangaon cab service provides dependable transportation solutions for outstation travel between Pune and Mangaon. Vehicles are suitable for long-distance travel ensuring safe and smooth journeys for individuals, families, and groups. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Ideal for business travel, tourism trips, Konkan tours, and family outstation travel. Flexible booking options allow convenient cab service reservations."
  },
  {
    name: "Pune to Mangaon Taxi Fare",
    description: "Pune to Mangaon taxi fare service provides transparent and reliable transportation options for travelers planning budget-friendly travel between Pune and Mangaon. Travelers can enjoy smooth journeys with experienced drivers familiar with Konkan routes and ghat road conditions. Comfortable vehicles ensure timely travel with safe transportation services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient taxi fare cab reservations."
  },
  {
    name: "Pune to Mangaon One Way Cab",
    description: "Pune to Mangaon one way cab service provides economical and comfortable transportation for travelers planning one-side travel between Pune and Mangaon. Comfortable vehicles ensure smooth highway travel suitable for business trips, tourism, beach holidays, and family travel. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient one-way cab reservations."
  },
  {
    name: "Pune to Mangaon Round Trip Taxi",
    description: "Pune to Mangaon round trip taxi service offers spacious transportation for families and groups traveling between Pune and Mangaon with return travel options. Vehicles offer comfortable seating, luggage capacity, and smooth highway performance suitable for family outings and Konkan travel. Professional chauffeurs ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient round trip taxi reservations."
  },
  {
    name: "Pune to Mangaon Cab Booking",
    description: "Pune to Mangaon cab booking service provides premium transportation for passengers seeking comfortable and reliable Konkan outstation travel. Vehicles offer spacious seating, smooth ride quality, and luggage space suitable for tourism, business trips, and family travel. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient cab booking reservations."
  },
  {
    name: "Cheap Pune to Mangaon Cab",
    description: "Cheap Pune to Mangaon cab service offers economical and comfortable transportation for solo travelers, couples, and small families traveling between Pune and Mangaon. Vehicles provide smooth highway travel with comfortable seating and luggage space suitable for one-way and round-trip journeys. Professional drivers ensure punctual pickup and safe driving services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient low-cost cab reservations."
  },
  {
    name: "Best Pune to Mangaon Taxi",
    description: "Best Pune to Mangaon taxi service offers dependable transportation for passengers planning direct outstation travel between Pune and Mangaon. Comfortable vehicles ensure smooth highway travel suitable for tourism, business travel, Konkan holidays, and family trips. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient taxi reservations."
  },
  {
    name: "Sedan Pune to Mangaon Cab",
    description: "Sedan Pune to Mangaon cab service provides reliable transportation for travelers planning long-distance journeys between Pune and Mangaon. Sedan vehicles ensure smooth and safe travel suitable for tourists, families, business travelers, and vacation travelers. Professional chauffeurs ensure timely pickup and dependable transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient sedan cab reservations."
  },
  {
    name: "SUV Pune to Mangaon Taxi",
    description: "SUV Pune to Mangaon taxi service offers comfortable transportation for passengers looking for spacious and reliable travel services between Pune and Mangaon. SUV vehicles ensure reliable local and highway travel with experienced chauffeurs offering safe and smooth journeys. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Ideal for business trips, family tours, Konkan travel, and outstation travel requirements. Flexible booking options allow convenient SUV taxi reservations."
  },
  {
    name: "Innova Pune to Mangaon Cab",
    description: "Innova Pune to Mangaon cab service provides dependable transportation for passengers planning premium outstation travel between Pune and Mangaon. Innova vehicles ensure smooth highway travel suitable for tourism, Konkan tours, airport visits, and family vacations. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Innova cab reservations."
  },
  {
    name: "Konkan Highway Cab Pune Mangaon",
    description: "Konkan highway cab Pune Mangaon service provides affordable and convenient transportation for passengers traveling between Pune and Mangaon through scenic Konkan highway routes. Vehicles ensure reliable highway travel with experienced drivers offering safe and smooth journeys. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Ideal for tourists, family travelers, Konkan holiday trips, and long-distance outstation travel requirements. Flexible booking options allow convenient Konkan highway cab reservations."
  }
],

tableData: [
  ["Pune to Mangaon Cab", "Pune to Mangaon Taxi"],
  ["Cab from Pune to Mangaon", "Taxi from Pune to Mangaon"],
  ["Pune to Mangaon Cab Service", "Pune to Mangaon Taxi Fare"],
  ["Pune to Mangaon One Way Cab", "Pune to Mangaon Round Trip Taxi"],
  ["Pune to Mangaon Cab Booking", "Cheap Pune to Mangaon Cab"],
  ["Best Pune to Mangaon Taxi", "Sedan Pune to Mangaon Cab"],
  ["SUV Pune to Mangaon Taxi", "Innova Pune to Mangaon Cab"],
  ["Konkan Highway Cab Pune Mangaon", "Pune to Mangaon Cab"]
],


 whychoose: [
      {
        WhyChooseheading: "Reliable Pune to Mangaon Cab Service",
        WhyChoosedescription: "Shivai Travels provides reliable Pune to Mangaon cab service with professional drivers, comfortable vehicles, and punctual pickup for smooth and safe Konkan travel."
      },
      {
        WhyChooseheading: "Affordable Pune to Mangaon Taxi Fare",
        WhyChoosedescription: "Shivai Travels offers affordable Pune to Mangaon cab pricing with transparent fare details and no hidden charges. Customers receive complete fare information before confirming their booking."
      },
      {
        WhyChooseheading: "24/7 Mangaon Cab Availability",
        WhyChoosedescription: "Our Pune to Mangaon cab service operates 24 hours a day for family travel, Konkan trips, business journeys, weekend travel, and emergency transportation requirements."
      },
      {
        WhyChooseheading: "Comfortable & Clean AC Cabs",
        WhyChoosedescription: "All taxis provided by Shivai Travels are fully air-conditioned, sanitized, and regularly maintained to provide comfortable long-distance travel experiences for passengers."
      },
      {
        WhyChooseheading: "One Way & Round Trip Cab Booking",
        WhyChoosedescription: "Shivai Travels offers flexible travel options including one-way Pune to Mangaon taxi service, round-trip bookings, Konkan travel, and customized outstation travel packages."
      },
      {
        WhyChooseheading: "Wide Range of Cab Vehicle Choices",
        WhyChoosedescription: "Customers can choose from sedan taxis, Ertiga, Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for individuals, families, tourists, and group tours."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides convenient pickup from homes, offices, hotels, Pune Airport, railway stations, and all major Pune areas including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Konkan Routes",
        WhyChoosedescription: "Our experienced drivers are familiar with Pune to Mangaon highway and ghat routes, ensuring safe driving, smooth travel, and timely arrival for every journey."
      }
    ]
  };

  const faqData = [
    { question: "What is Pune to Mangaon cab service?", answer: "Pune to Mangaon cab service provides comfortable taxi transportation between Pune and Mangaon for Konkan travel, family trips, and business journeys." },
    { question: "Is Pune to Mangaon cab service available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 Pune to Mangaon cab service." },
    { question: "Which vehicles are available for Pune to Mangaon travel?", answer: "Shivai Travels offers sedan taxis, Ertiga, Innova, Innova Crysta, and Tempo Travellers." },
    { question: "Can I book a one-way cab from Pune to Mangaon?", answer: "Yes, customers can book one-way as well as round-trip Pune to Mangaon taxi services." },
    { question: "Do you provide round-trip taxi service for Mangaon travel?", answer: "Yes, Shivai Travels provides both one-way and round-trip taxi services for Mangaon." },
    { question: "Are all Pune to Mangaon taxis air-conditioned?", answer: "Yes, all taxis are fully air-conditioned and maintained for comfortable travel." },
    { question: "Can I book Pune to Mangaon cab service online?", answer: "Yes, customers can easily book Pune to Mangaon cab service online or through phone booking." },
    { question: "Do you provide cabs for family and group travel?", answer: "Yes, Shivai Travels provides comfortable vehicles suitable for family tours and group travel." },
    { question: "Are Pune to Mangaon cab fares transparent?", answer: "Yes, Shivai Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Pune to Mangaon cab service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, and peak travel seasons." }
  ];

const testimonials = [
  {
    id: 1,
    name: "Mr. Prakash Jadhav",
    feedback:
      "Had a comfortable Pune to Mangaon cab journey with a well-maintained vehicle and a professional driver who ensured a smooth and safe coastal travel experience.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Kulkarni",
    feedback:
      "The Pune to Mangaon taxi service was very reliable with timely pickup, clean car, and a relaxed travel experience making the journey hassle-free.",
    rating: 5
  }
];






  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mangaon Cab Service",
  "image": "https://shivaitravels.com/assets/images/pune-to-mangaon-cab.jpg",
  "description": "Book Pune to Mangaon Cab Service for safe and comfortable Konkan highway travel. Shivai Travels offers reliable one-way and round-trip taxi booking with sedan, SUV, Innova, and luxury cab options available 24x7 for intercity and long-distance journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Shivai Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹10/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/pune-to-mangaon-cab-service"
  }
};




  return (
    <div>

<Helmet>
  <title>Pune to Mangaon Cab Service | Konkan Highway Taxi | +91 9689815477</title>

  <meta
    name="description"
    content="Book Pune to Mangaon cab service for safe Konkan highway travel. Affordable one-way and round-trip taxi options with sedan, SUV, Innova, and luxury cabs available 24x7."
  />

  <meta
    name="keywords"
    content="pune to mangaon cab, pune to mangaon taxi, cab from pune to mangaon, taxi from pune to mangaon, pune to mangaon cab service, pune to mangaon taxi fare, pune to mangaon one way cab, pune to mangaon round trip taxi, pune to mangaon cab booking, cheap pune to mangaon cab, best pune to mangaon taxi, sedan pune to mangaon cab, suv pune to mangaon taxi, innova pune to mangaon cab, konkan highway cab pune mangaon"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/101.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomangaoncab;